import React from 'react'

import './component1.css'

const Component1 = (props) => {
  return (
    <div className="component1-container">
      <span className="component1-text10">
        <span className="component1-text11">RECORDING</span>
        <br className="component1-text12"></br>
        <span className="component1-text13">
          Vocal Tracking
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <br className="component1-text14"></br>
        <span className="component1-text15">Full band tracking</span>
        <br className="component1-text16"></br>
        <span className="component1-text17">
          Live SessionsPodcast, Voiceover &amp; Radio IDs
        </span>
        <br className="component1-text18"></br>
        <span className="component1-text19">Broadcast for livestream</span>
        <br className="component1-text20"></br>
        <br className="component1-text21"></br>
        <span className="component1-text22">SOFTWARE I USE</span>
        <br className="component1-text23"></br>
        <span className="component1-text24">Pro Tools HD</span>
        <br className="component1-text25"></br>
        <span className="component1-text26">Logic Pro XIzotope RX</span>
        <br className="component1-text27"></br>
        <span className="component1-text28">Fab Filter Pro</span>
        <br className="component1-text29"></br>
        <span className="component1-text30">UAD Console</span>
        <br className="component1-text31"></br>
        <span className="component1-text32">Soundtoys</span>
        <br className="component1-text33"></br>
        <br className="component1-text34"></br>
        <span className="component1-text35">HARDWARE I USE</span>
        <br className="component1-text36"></br>
        <span className="component1-text37">SSL4000G Series</span>
        <br className="component1-text38"></br>
        <span className="component1-text39">SSL AWS</span>
        <br className="component1-text40"></br>
        <span className="component1-text41">Dante Level 1 Certification</span>
        <br className="component1-text42"></br>
        <span className="component1-text43">
          Universal Audio Apollo Systems
        </span>
        <br className="component1-text44"></br>
        <span className="component1-text45">
          Wireless In Ear Monitoring SystemsWireless Microphone Systems
        </span>
        <br className="component1-text46"></br>
        <span className="component1-text47">Ferrofish Converters</span>
        <br className="component1-text48"></br>
        <span className="component1-text49">Antelope Orion Converters</span>
        <br className="component1-text50"></br>
        <br className="component1-text51"></br>
        <span className="component1-text52">MIXING</span>
        <br className="component1-text53"></br>
        <span className="component1-text54">
          Mixing for commercial music releases
        </span>
        <br className="component1-text55"></br>
        <span className="component1-text56">
          Audio mixing for live video sessions
        </span>
        <br className="component1-text57"></br>
        <span className="component1-text58">Pro Tools HDLogic Pro X</span>
        <br className="component1-text59"></br>
        <br className="component1-text60"></br>
        <span className="component1-text61">STUDIOS IVE WORKED FOR</span>
        <br className="component1-text62"></br>
        <span className="component1-text63">Circle Studios by Sony Music</span>
        <br className="component1-text64"></br>
        <span className="component1-text65">
          Red Bull Studios London &amp; Berlin
        </span>
        <br className="component1-text66"></br>
        <span className="component1-text67">Noatune Studios London</span>
        <br className="component1-text68"></br>
        <br className="component1-text69"></br>
        <br className="component1-text70"></br>
        <span className="component1-text71">AWARDS</span>
        <br className="component1-text72"></br>
        <span className="component1-text73">
          Shure x Red Bull’s Soundscapes Competition
        </span>
        <br className="component1-text74"></br>
        <span className="component1-text75">
          Madison Square Garden’s Up and Coming Award
        </span>
        <br className="component1-text76"></br>
        <br className="component1-text77"></br>
        <span className="component1-text78">MASTERCLASS</span>
        <br className="component1-text79"></br>
        <span className="component1-text80">
          Pop Beuro x SAE Elextronic Barcamp
        </span>
        <br></br>
        <br></br>
      </span>
    </div>
  )
}

export default Component1
